// src/App.js
import React from 'react';
import ChessGame from './ChessGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ChessGame />
      </header>
    </div>
  );
}

export default App;
